import { render, staticRenderFns } from "./JgBespokeFanduel.vue?vue&type=template&id=ecc45d3c&scoped=true&"
import script from "./JgBespokeFanduel.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeFanduel.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeFanduel.vue?vue&type=style&index=0&id=ecc45d3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc45d3c",
  null
  
)

export default component.exports